// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-member-details .bios {
  width: 100%;
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/team-member-details/team-member-details.component.scss"],"names":[],"mappings":"AACC;EACC,WAAA;EACA,aAAA;AAAF","sourcesContent":[".team-member-details{\n\t.bios{\n\t\twidth: 100%;\n\t\theight: 100px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
